import React from "react";
import DelegationSelection from "./DelegationSelection";
import DelegationComponent from "./DelegationComponent";
import SearchIcon from "../../assets/images/icons/SearchGrey.svg";
import LabelComponent from "../UniversalComponents/LabelComponent";

const DelegationMultiSelect = ({
  formData,
  isFormDisabled,
  isSearchBarOpen,
  taskassignedtoref,
  handleMouseEnter,
  handleMouseLeave,
  handleCheck,
  personTableData,
  handleSelectPerson,
  handleRemovePerson,
  searchTerm,
  isEditTask,
  depth,
  personCountAllowed,
  showSearchBar,
  noLabel,
  className,
}) => {
  // const isTaskCategory = formData?.category_id?.toLowerCase() === "01c04298-9231-11f0-b592-bc2411f4d589"; // for task single assigned_to vaild
  const isTaskCategory = false; // for task single assigned_to vaild be hold
  const renderSelectedPersons = () => (
    <>
      {formData?.assigned_to?.length > 0 ? (
        formData?.assigned_to.map((person, index) => (
          <span
            key={index}
            className="flex items-center bg-1D5D9B text-white rounded px-2 py-0.5 text-xs gap-1 min-w-fit"
          >
            {person.name}
            {!isFormDisabled && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemovePerson(e, person);
                }}
                className="text-white hover:text-gray-200"
              >
                &times;
              </button>
            )}
          </span>
        ))
      ) : (
        <span className="text-868686">Select persons</span>
      )}
    </>
  );

  const renderSearchIcon = () => (
    <span className={`flex items-center ${isSearchBarOpen[depth] && "border border-1D5D9B"}`}>
      <img src={SearchIcon} />
      {/* <SearchIcon noBorder /> */}
      {/* <SearchIcon /> */}
      {/* You can replace this with a separate <SearchIcon /> component */}
    </span>
  );

  const renderDropdown = () =>
    isSearchBarOpen[depth] && (
      <DelegationSelection
        depth={depth}
        handleMouseLeave={handleMouseLeave}
        handleCheck={handleCheck}
        formData={formData}
        //included .data as per new api response
        personTableData={personTableData?.data?.filter(
          (person) => !formData.assigned_to.some((selected) => selected.id === person.id)
        )}
        handleSelectPerson={handleSelectPerson}
        searchTerm={searchTerm}
        isMultiSelect={true}
        personCountAllowed={personCountAllowed}
      />
    );

  return (
    <div className="basis-5/5 mb-1 col-span-2">
      {!noLabel && (
        <LabelComponent
          labelText="Assigned To"
          htmlFor="assigned_to"
          size="small"
          isMandatory="assigned_to"
          isFormDisabled={isFormDisabled}
          className={className}
        />
      )}

      {showSearchBar || isTaskCategory ? (
        <div
          className={`flex items-center space-x-1 w-full ${
            isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"
          }  ${isSearchBarOpen[depth] ? "border-1D5D9B" : "border-DFE2E5"}`}
          onClick={() => !isFormDisabled && handleMouseEnter(depth)}
        >
          <div
            ref={taskassignedtoref}
            className={`rounded  text-sm block min-h-7 px-2 py-1 flex  gap-1 items-center cursor-text overflow-x-auto scrollbar-thin w-full shadow-r-md `}
          >
            {renderSelectedPersons()}
          </div>
          {renderSearchIcon()}
          {renderDropdown()}
        </div>
      ) : (
        <DelegationComponent
          depth={depth}
          handleMouseLeave={handleMouseLeave}
          handleCheck={handleCheck}
          formData={formData}
          personTableData={personTableData}
          handleSelectPerson={handleSelectPerson}
          searchTerm={searchTerm}
          isFormDisabled={isFormDisabled}
          isEditTask={isEditTask}
          taskassignedtoref={taskassignedtoref}
          handleMouseEnter={handleMouseEnter}
          isSearchBarOpen={isSearchBarOpen}
          isMultiSelect={true}
          personCountAllowed={personCountAllowed}
        />
      )}
    </div>
  );
};

export default DelegationMultiSelect;
